
import React from 'react'
import { MDBBreadcrumb, MDBBreadcrumbItem, MDBTypography } from 'mdb-react-ui-kit'
import { Link } from 'react-router-dom'
import { List } from 'rsuite';

export const ReportsPQRS = (props) => {
    const { breadCrums } = props;

    const baseURL = 'https://curaduria1bucaramanga.com/public_docs/OTHERS/reports/pqrs/';

    return <>
        <div className='container'>
            <div className='row py-4 d-flex justify-content-center'>
                <MDBBreadcrumb className="mx-5">
                    <MDBBreadcrumbItem>
                        <Link to={'/home'}><i class="fas fa-home"></i> <label className="text-uppercase">{breadCrums.bc_01}</label></Link>
                    </MDBBreadcrumbItem>
                    <MDBBreadcrumbItem>
                        <Link to={'/reports'}><i class="far fa-bookmark"></i> <label className="text-uppercase">INFORMES</label></Link>
                    </MDBBreadcrumbItem>
                    <MDBBreadcrumbItem active><i class="far fa-bookmark"></i> <label className="text-uppercase">Informes trimestrales sobre acceso a información, quejas y reclamos</label></MDBBreadcrumbItem>
                </MDBBreadcrumb>
                <div className="col-lg-10">
                    <div className='' style={{ backgroundColor: '#1b83c4', borderRadius: '2px' }}>
                        <div class="row justify-content-center px-4 mx-2">
                            <div class="col-11 text-center py-1" style={{ color: ' white ' }}>
                                <h2 className='px-2 py-0 fw-normal'>Informes trimestrales sobre acceso a información, quejas y reclamos</h2>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <List size="sm" bordered>
                        <List.Item><a className='text-dark' href={`${baseURL}AÑO 2022.pdf`} target="_blank"><i class="fas fa-caret-right"></i> AÑO 2022</a></List.Item>
                        <List.Item><a className='text-dark' href={`${baseURL}1 Trimestre 2022.pdf`} target="_blank"><i class="fas fa-caret-right"></i> 1 Trimestre 2022</a></List.Item>
                        <List.Item><a className='text-dark' href={`${baseURL}2 Trimestre 2022.pdf`} target="_blank"><i class="fas fa-caret-right"></i> 2 Trimestre 2022</a></List.Item>
                        <List.Item><a className='text-dark' href={`${baseURL}3 Trimestre 2022.pdf`} target="_blank"><i class="fas fa-caret-right"></i> 3 Trimestre 2022</a></List.Item>
                        <List.Item><a className='text-dark' href={`${baseURL}4 Trismestre 2022.pdf`} target="_blank"><i class="fas fa-caret-right"></i> 4 Trimestre 2022</a></List.Item>

                        <List.Item><a className='text-dark' href={`${baseURL}AÑO 2023.pdf`} target="_blank"><i class="fas fa-caret-right"></i> AÑO 2023</a></List.Item>
                        <List.Item><a className='text-dark' href={`${baseURL}1 Trimestre 2023.pdf`} target="_blank"><i class="fas fa-caret-right"></i> 1 Trimestre 2023</a></List.Item>
                        <List.Item><a className='text-dark' href={`${baseURL}2 Trimestre 2023.pdf`} target="_blank"><i class="fas fa-caret-right"></i> 2 Trimestre 2023</a></List.Item>
                        <List.Item><a className='text-dark' href={`${baseURL}3 TRIMESTRE 2023.pdf`} target="_blank"><i class="fas fa-caret-right"></i> 3 Trimestre 2023</a></List.Item>
                        <List.Item><a className='text-dark' href={`${baseURL}4 TRIMESTRE 2023.pdf`} target="_blank"><i class="fas fa-caret-right"></i> 4 Trimestre 2023</a></List.Item>

                        <List.Item><i class="fas fa-caret-right"></i> AÑO 2024</List.Item>
                        <List.Item><a className='text-dark' href={`${baseURL}1 TRIMESTRE 2024.pdf`} target="_blank"><i class="fas fa-caret-right"></i> 1 Trimestre 2024</a></List.Item>
                        <List.Item><a className='text-dark' href={`${baseURL}2 TRIMESTRE 2024.pdf`} target="_blank"><i class="fas fa-caret-right"></i> 2 Trimestre 2024</a></List.Item>
                        <List.Item><a className='text-dark' href={`${baseURL}REPORTE PQRS 3 y 4 TRIMESTES 2024.pdf`} target="_blank"><i class="fas fa-caret-right"></i> 3 y 4 Trimestre 2024</a></List.Item>
                        
                        <List.Item><i class="fas fa-caret-right"></i> AÑO 2025</List.Item>
                        <List.Item><a className='text-dark' href={`${baseURL}REPORTE PQRS 1 Y 2 TRIMESTRE 2025.pdf`} target="_blank"><i class="fas fa-caret-right"></i> 1 y 2 Trimestre 2025</a></List.Item>
                    </List>
                </div>
            </div>
        </div>
    </>
}
